import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { apiErrorMessage } from '../../api/client';
import { takeStoredVerifier, googleRedirectUri } from '../../auth/pkce';

export default function GoogleCallback() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithGoogleCode } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return; // the code is single-use
    fired.current = true;

    const code = params.get('code');
    if (!code) {
      setError(
        params.get('error') === 'access_denied'
          ? 'Google sign-in was cancelled.'
          : 'Google did not return an authorisation code.',
      );
      return;
    }
    loginWithGoogleCode(code, takeStoredVerifier(), googleRedirectUri())
      .then(() => navigate('/', { replace: true }))
      .catch((err) => setError(apiErrorMessage(err, 'Google sign-in failed')));
  }, [params, loginWithGoogleCode, navigate]);

  return (
    <section data-testid="page-googlecallback" className="mx-auto max-w-sm pt-6 text-center">
      <h1 className="text-2xl font-bold">Signing you in…</h1>
      {error ? (
        <div className="mt-6">
          <p role="alert" className="text-red-600">
            {error}
          </p>
          <Link to="/login" className="mt-3 inline-block text-emerald-700 hover:underline">
            Back to sign in
          </Link>
        </div>
      ) : (
        <p className="mt-6 text-stone-600">Completing Google sign-in.</p>
      )}
    </section>
  );
}
